import { EmailProvider } from '../../../api';
import { FormValues } from './types';

export const prepareSubmitData = (values: FormValues): EmailProvider => {
  const { provider_type, provider_settings, ...data } = values;

  const resultData = Object.entries(data).reduce(
    (prev, [key, value]) => {
      if (!value) {
        return { ...prev, [key]: '' };
      }
      return { ...prev, [key]: value };
    },
    { custom_email: '', from_email_name: '' }
  );

  const resultProviderData = Object.entries(provider_settings).reduce(
    (prev, [key, value]) => {
      if (!value) {
        return { ...prev, [key]: '' };
      }
      return { ...prev, [key]: value };
    },
    { sendgrid_api_key: '' }
  );

  return {
    ...resultData,
    provider_settings: provider_type.send_grid ? resultProviderData : { sendgrid_api_key: '' }
  };
};
